// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__h3nOs","content":"LoadingAlert_content__2Ll2W"};